import { DataConnectionList } from "@encoo-web/encoo-ui";
import { createEntityModel } from "src/store/models/entity/_shared";

export const DataConnectionListEntityModel = createEntityModel<
  DataConnectionList
>();
